<template>
  <div class="server-card">
    <p class="title">填写学员服务卡</p>
    <van-form ref="myvantform" @submit="onSubmit">
      <!-- <van-field
        v-model="realName"
        required
        name="realName"
        label="姓名"
        maxlength="20"
        placeholder="姓名"
        :rules="[{ required: true, message: '请输入姓名' }]"
      /> -->
      <van-field
        v-model="phone"
        required
        name="phone"
        label="手机号"
        maxlength="11"
        placeholder="手机号"
        :rules="[
          { required: true, message: '请输入手机号' },
          { validator, message: '请输入正确的手机号' },
        ]"
      />
      <van-field
        readonly
        clickable
        :value="subjectname"
        name="type"
        label="意向学科"
        clearable
        clear-trigger="always"
        placeholder="请选择"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          value-key="name"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <div class="look-btn">
        <van-button block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { wesubject, addUserInfo } from "@/server/api.js";
import { Toast } from "vant";
export default {
  data() {
    return {
      // realName: "",
      phone: "",
      subjectname: "",
      subjectId: "",
      subjectOptions: [],
      columns: [],
      showPicker: false,
      wechatUserId: "",
    };
  },
  mounted() {
    this.InitSubject();
    this.wechatUserId = this.$route.query.userId || "";
  },
  methods: {
    async InitSubject() {
      let res = await wesubject();
      this.columns = res.data;
    },
    onConfirm(val) {
      this.subjectname = val.name;
      this.subjectId = val.id;
      this.showPicker = false;
    },
    onSubmit() {
      console.log(this.subjectId, this.phone);
      let obj = {
        externalUserid: this.wechatUserId,
        phone: this.phone,
        // realName: this.realName,
        subjectId: this.subjectId,
        subjectName: this.subjectname || "",
      };
      addUserInfo(obj).then((res) => {
        console.log(res);
        if (res.code !== "200") return Toast.fail(res.msg);
        Toast.success("录入成功");
        // this.realName = "";
        this.phone = "";
        this.subjectname = "";
        this.subjectId = "";
      });
    },
    validator(val) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(val);
    },
  },
};
</script>
<style scoped lang="less">
.server-card {
  height: 100vh;
  padding: 29px;
  background: #fff;
  font-size: 28px;
  .title {
    margin-top: 27px;
  }
  .van-cell {
    padding-right: 0;
    margin-top: 35px;
    // height: 80px;
    font-size: 28px;
  }
  .van-cell::after {
    left: 0;
  }
  .van-field__label {
    // width: 70px;
    font-size: 28px;
  }
  // .van-field__body {
  //   height: 80px;
  // }
  /deep/.van-field__error-message {
    font-size: 24px;
  }
  .van-cell {
    padding: 10px 33px;
  }
  .van-cell--required::before {
    font-size: 30px;
    padding-top: 4px;
  }
  .look-btn {
    margin-top: 101px;
    button {
      height: 80px;
      font-size: 28px;
    }
  }
}
</style>
